import React, { Component } from "react";
import { Table, Row, Col } from "antd";
import { strings } from "../../../helpers";

export default class PharmacyClinicListView extends Component {
  render() {
    const { details, navigateToClinicDetails } = this.props;
    const { clinics } = details;

    const columns = [
      {
        title: "Name",
        key: "name",
        align: "left",
        width: "30%",
        render: record => (
          <a href="" onClick={e => navigateToClinicDetails(e, record.id)}>
            {record.name || "--"}
          </a>
        )
      },
      {
        title: "phone number",
        key: "phone_number",
        align: "left",
        render: record => <div>{record.phone_number || "--"}</div>
      }
    ];
    return (
      <div className="content-container">
        <div className="backgroundWhite">
          <Row type="flex" justify="space-between" align="middle">
            <Col span={5} className="heading-domain">
              {strings.dashboard.clinic}
            </Col>
          </Row>

          <div className="mt-20 kc-block white-bg round-borders-4x">
            <Table
              columns={columns}
              dataSource={clinics}
              pagination={false}
              rowKey="id"
            />
          </div>
        </div>
      </div>
    );
  }
}
